interface ITableCellRootProps {
  style: React.CSSProperties;
  children: React.ReactNode;
  colspan: number | undefined;
}

export const TableCellRoot = (props: ITableCellRootProps) => {
  const getStyle = () => {
    return Object.assign(
      {},
      props.style,
      props?.colspan ? { minWidth: '100%' } : {}
    );
  };
  return (
    <div className="table-cell-root" style={getStyle()}>
      {props.children}
    </div>
  );
};
